<div mat-dialog-title class="dialog-header bg-light p-3 border-bottom">
    <h2 class="h5 mb-0 text-primary fw-bold">Nuova Prenotazione Appuntamento</h2>
</div>

<mat-dialog-content class="pt-4">
    <form [formGroup]="prenotazioneForm">
        <div class="row">
            <div class="col-12 mb-3">
                <mat-form-field appearance="outline" class="w-100 p-2">
                    <mat-label>Codice Fiscale Paziente</mat-label>
                    <input matInput formControlName="cf" [matAutocomplete]="auto" placeholder="Inserisci i 16 caratteri"
                        style="text-transform: uppercase">

                    <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption>
                        <mat-option *ngIf="isLoadingCf" class="is-loading">
                            <mat-spinner diameter="20"></mat-spinner> Caricamento...
                        </mat-option>
                        <mat-option *ngFor="let cf of filteredCf" [value]="cf">
                            {{ cf }}
                        </mat-option>
                    </mat-autocomplete>

                    <mat-hint *ngIf="!isLoadingCf">Digita almeno 3 caratteri per la ricerca</mat-hint>

                    <mat-error *ngIf="prenotazioneForm.get('cf')?.hasError('pattern')">
                        Formato non valido
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-12">
                <mat-form-field appearance="outline" class="w-100 p-2">
                    <mat-label>Note / Motivazione</mat-label>
                    <textarea matInput formControlName="note" rows="3"
                        placeholder="Inserisci eventuali dettagli aggiuntivi"></textarea>
                </mat-form-field>
            </div>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="p-3 bg-light border-top">
    <button class="btn btn-outline-secondary btn-sm me-2" (click)="onAnnulla()">
        Annulla
    </button>
    <button class="btn btn-primary btn-sm" [disabled]="prenotazioneForm.invalid" (click)="onConferma()">
        Conferma Prenotazione
    </button>
</mat-dialog-actions>